import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* adminAssignementsUtilisateurCoursAjouterAssignementUtilisateurCoursSaga (action) {

    yield put(actions.adminAssignementsUtilisateurCoursAjouterAssignementUtilisateurCoursStart());

    const assignementUtilisateurCours = action.payload.assignementUtilisateurCours;

    try {
        const response = yield axios.post(api.ajouterAssignementUtilisateurCours,assignementUtilisateurCours);
        yield put(actions.adminAssignementsUtilisateurCoursAjouterAssignementUtilisateurCoursSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.adminAssignementsUtilisateurCoursAjouterAssignementUtilisateurCoursFail(error.response.data.error));
        }else {
            yield put(actions.adminAssignementsUtilisateurCoursAjouterAssignementUtilisateurCoursFail("There's an error!"));
        }
    }
}

